import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DeliveryTypeEntity } from './delivery-type.model';

@Injectable({
    providedIn: 'root'
})
export class DeliveryTypeService {
    private httpClient = inject(HttpClient);

    getDeliveryTypes(subscriberKey: number) {
        return this.httpClient.get<DeliveryTypeEntity[]>(`api/subscriber/${subscriberKey}/delivery-types`);
    }
}
